import { render } from "./Totals.vue?vue&type=template&id=2214d5dc&scoped=true"
import script from "./Totals.vue?vue&type=script&lang=js"
export * from "./Totals.vue?vue&type=script&lang=js"

import "./Totals.vue?vue&type=style&index=0&id=2214d5dc&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2214d5dc"]])

export default __exports__